import React, { Component } from 'react'

import './notifications.scss'

class Notifications extends Component {
	constructor(props) {
		super(props)
		this.state = {
			showIcon: this.props.showIcon === true
		}
	}

	render() {
		let classes = ['vbui--notifications', this.props.classes, this.props.state].join(' ')
		let icon = 'icon-icon-warning'
		if (this.props.state === 'success') {
			icon = 'icon-icon-tick'
		}
		return (
			<div className={classes}>
				<div className="container-icon">
					<span className={icon}></span>
				</div>
				<div className="container-text">{this.props.children}</div>
			</div>
		)
	}
}

export default Notifications
